/**
 * 날짜 배열을 커스텀 문자열 형식으로 변환
 * @param dateArray - Date 객체 배열
 * @returns 'YYYYMMDD' 형식의 문자열 배열
 */
export function formatDateToCustomString(dateArray: Date[]): string[] {
  return dateArray.map(date => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
  });
}
